import script from "./ProfilePicture.vue?vue&type=script&lang=ts&setup=true"
export * from "./ProfilePicture.vue?vue&type=script&lang=ts&setup=true"

import "./ProfilePicture.vue?vue&type=style&index=0&id=e6ef107c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-e6ef107c"]])

export default __exports__